import { render, staticRenderFns } from "./FormReportingChannel.vue?vue&type=template&id=a50bf316&"
import script from "./FormReportingChannel.vue?vue&type=script&lang=js&"
export * from "./FormReportingChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a50bf316')) {
      api.createRecord('a50bf316', component.options)
    } else {
      api.reload('a50bf316', component.options)
    }
    module.hot.accept("./FormReportingChannel.vue?vue&type=template&id=a50bf316&", function () {
      api.rerender('a50bf316', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/reporting-channel/handling/FormReportingChannel.vue"
export default component.exports